const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved) {
      window.setTimeout(() => {
        this.moveToElement.appendChild(this)
      }, parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0)
    }

    this.addEventListener('scroll', this.onScroll.bind(this), {
      passive: true,
    })
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }

  onScroll = event => {
    const drawersEl = event.target

    const scrollTop = drawersEl.scrollTop

    this.toggleAttribute('scrollstart', scrollTop <= 40)
    this.toggleAttribute('scrollend', scrollTop >= 40)
  }
}

customElements.define('site-drawer', SiteDrawer)
